<template>
  <el-dialog
    class="contact-customer-service-wrapper"
    :visible.sync="visible"
    :show-close="false"
    :width="contactWidth"
    top="20vh"
    :before-close="close"
  >
    <div class="content-wrapper">
      <div class="qrcode-head">联系客服</div>
      <div class="qrcode-desc">{{contactCustomerServiceDialogData.title}}</div>
      <div
        v-if="contactQrcodeCount>1"
        class="qrcode-content"
        style="justify-content:space-between"
      >
        <div class="wid_bf_46">
          <div class="title">{{contactCustomerServiceDialogData.contact_name1}}</div>
          <el-image
            class="img"
            :src="contactCustomerServiceDialogData.contact_qrcode1"
          ></el-image>
        </div>
        <div class="wid_bf_46">
          <div class="title">{{contactCustomerServiceDialogData.contact_name2}}</div>
          <el-image
            class="img"
            :src="contactCustomerServiceDialogData.contact_qrcode2"
          ></el-image>
        </div>
      </div>
      <div
        v-else
        class="qrcode-content"
      >
        <div class="wid_bf_98">
          <div class="title">{{contactCustomerServiceDialogData.contact_name1}}</div>
          <el-image
            class="img"
            :src="contactCustomerServiceDialogData.contact_qrcode1"
          ></el-image>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "connect-people",
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      contactCustomerServiceDialogData: {          //  弹框配置
        title: '使用微信扫一扫以下二维码咨询更多产品问题',
        contact_name1: '客服-Joy',
        contact_name2: '客服-Fiona',
        contact_qrcode1: process.env.VUE_APP_PIC_DOMAIN + '/public/contact.jpg',
        contact_qrcode2: process.env.VUE_APP_PIC_DOMAIN + '/public/wechat.jpg',
      },
      contactWidth: '900px',
      contactQrcodeCount: 0,
    }
  },
  mounted() {
    this.getSbrandData();       //  获得当前关联的品牌服务数据
  },
  methods: {
    /**
     * 关闭操作
     */
    close() {
      this.$emit("close")
    },
    /**
     * 获得当前关联的品牌服务数据
     */
    getSbrandData() {
      this.$user.getLoginUserData({
        success: (result) => {
          const sbrandData = result.user_sbrand_data;
          if (sbrandData.sbrand_setting.contact_desc) {
            this.contactCustomerServiceDialogData.title = sbrandData.sbrand_setting.contact_desc
          }
          if (sbrandData.sbrand_setting.contact_name) {
            this.contactCustomerServiceDialogData.contact_name1 = sbrandData.sbrand_setting.contact_name
            this.contactCustomerServiceDialogData.contact_name2 = sbrandData.sbrand_setting.contact_name
          }
          if (sbrandData.sbrand_setting.contact_name_other) {
            this.contactCustomerServiceDialogData.contact_name2 = sbrandData.sbrand_setting.contact_name_other
          }
          if (sbrandData.sbrand_setting.contact_qrcode1) {
            this.contactCustomerServiceDialogData.contact_qrcode1 = sbrandData.sbrand_setting.contact_qrcode1
            this.contactQrcodeCount = this.contactQrcodeCount+1;
          }
          if (sbrandData.sbrand_setting.contact_qrcode2) {
            this.contactCustomerServiceDialogData.contact_qrcode2 = sbrandData.sbrand_setting.contact_qrcode2
            this.contactQrcodeCount = this.contactQrcodeCount+1;
          }
          console.log('this.contactQrcodeCount', this.contactQrcodeCount);
          if (this.contactQrcodeCount == '2') {
            this.contactWidth = '900px';
          } else {
            this.contactWidth = '600px';
          }
        }, //  成功函数
        error: (result) => {

        }, //  失败函数
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.contact-customer-service-wrapper {
  ::v-deep(.el-dialog__header) {
    padding: 0px;
  }

  ::v-deep(.el-dialog__body) {
    padding: 20px;
  }

  .content-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 10px;
    padding-bottom: 20px;
    .qrcode-head {
      font-size: 20px;
      font-weight: bold;
      color: #000000;
    }
    .qrcode-desc {
      padding: 15px 0px 30px;
    }
    .qrcode-content {
      display: flex;
      flex-direction: row;

      align-items: center;
      width: 90%;
      .wid_bf_46 {
        width: 46%;
      }
      .wid_bf_98 {
        width: 98%;
      }
      .title {
        background: linear-gradient(-45deg, transparent 20px, #80bd01 0);
        width: 30%;
        color: #ffffff;
        padding: 5px 10px;
        margin-bottom: 20px;
      }
      .img {
        border: 1px solid rgb(247, 247, 247);
      }
    }
    .img {
      width: 100%;
    }

    .desc {
      padding: 10px;
      color: #80bd01;
    }
  }
}
</style>